import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';

export function FridayTableHU() {
    return (
      <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
        <Table sx={{ tableLayout: 'auto', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Időpont
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Program
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Terem
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  8:30
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important', fontSize: '18px !important' }}>
                  Regisztráció
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  PTE KPVK Bejárat
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  9:00
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Konferenciát megnyitja
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Prof. Dr. Miseta Attila</b>
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important' }}>
                    a Pécsi Tudományegyetem rektora
                  </Typography>

                  <Typography sx={{mt: 1, fontSize: '18px !important'}}>
                    <b>Prof. Dr. Szécsi Gábor</b>
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important' }}>
                    PTE Kultúratudományi, Pedagógiai és Vidékfejlesztési Karának dékánja
                  </Typography>

                  <Typography sx={{mt: 1, fontSize: '18px !important'}}>
                    <b>Dr. Dr. habil. Agora Zsuzsanna</b>
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important' }}>
                    a "Játék és társadalom" konferencia fő szervezője
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  9:30
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Angol nyelvű főelőadások magyar fordítással (Elnök: Dr. Dr. habil. Agora Zsuzsanna)
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Valeria Spazzoli</b> - az Európai Bizottság Foglalkoztatás, Szociális Ügyek és Társadalmi Befogadás Főigazgatóságának szakpolitikai asszisztense
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important' }}>
                    European Child Guarantee/ Az Európai Gyermekgarancia
                  </Typography>

                  <Typography sx={{mt: 1, fontSize: '18px !important'}}>
                    <b>Dr. Francesca Berti</b> - játékkutató, Free University of Bolzano
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Traditional Games and Heritage Education: connecting the past, the present and the future / 
                    Tradicionális játékok és a kulturális örökség oktatása: a múlt, a jelen és a jövő összekapcsolása
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  10:30
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography fontWeight="bold !important" fontSize='18px !important' textAlign='center'>
                    Társasjátékbemutató
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important', textAlign: 'center' }}>
                    <b>Dr. Dr. habil. Agora Zsuzsanna</b> (PTE KPVK) - <b>Dr. habil. V. Gilbert Edit</b> (PTE BTK) - <b>Dr. habil. Rab Virág</b> (PTE BTK) - <b>Nemes-Wéber Zsófia</b> - <b>Prof. Dr. Nemeskéri Zsolt</b> (PTE KPVK) - <b>Dr. habil. Zádori Iván</b> (PTE KPVK) - <b>Prof. Dr. Klein Sándor</b> (PTE KPVK)
                  </Typography>
                  <Typography sx={{mt: 2, fontStyle: 'italic !important', textAlign: 'center' }}>
                    Edukációs célú társasjátékfejlesztések a Pécsi Tudományegyetemen
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', textAlign: 'center' }}>
                    Rólunk szól! - Identitás és lokalitás az Ormánságban
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', textAlign: 'center' }}>
                    Identities in Between - European Destinies
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', textAlign: 'center' }}>
                    Dienes játéksorozat a matematikai gondolkodás fejlesztésére
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  11:30
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 1: Játékról a pedagógusképzésben (Elnök: Dr. habil. Bús Imre)
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Dr. Szabó Ildikó</b> - Pécsi Tudományegyetem Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    Hogyan győzd le a sárkányodat? Pedagógusképzés és -továbbképzés a STEM-oktatásban a DISCO+ nemzetközi projektben kidolgozott online komoly játék (serious game) alkalmazásával
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Dr. habil. Bethlenfalvy Ádám</b> - Károli Gáspár Református Egyetem, Bölcsészet- és Társadalomtudományi Kar
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    Játék és fiktív szerep a megértés szolgálatában
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Dr. Bajner Mária</b> - Pécsi Tudományegyetem Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    Az én sztorim, a te sztorid, az ő sztorija... Pedagógusjelölt nők meseválasztása
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                    12:30
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                  Szünet
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                    13:00
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 2: A játék jelentősége a gyermek életében (Elnök: Kazinczy Viktória)
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Major Tünde Kármen</b> - Pécsi Tudományegyetem Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    A játék filozófiája és pedagógiája a reflektív gondolkodás szolgálatában
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Ribarics Lívia</b> - Eszterházy Károly Katolikus Egyetem, Neveléstudományi Doktori Iskola
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    A játék szerepe az óvodáskori szociális és érzelmi kompetencia fejlesztésében
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important' }}>
                    <b>Dr. Kerekes Valéria</b> - <b>Dr. Böddi Zsófia</b> - <b>Bavalics Laura</b> - Eötvös Loránd Tudományegyetem, Tanító és Óvóképző Kar
                  </Typography>
                  <Typography sx={{fontStyle: 'italic !important' }}>
                    A gyermekek játéka- és ami mögötte van - könyvbemutató
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important'}}>
                  Fsz A
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                    14:00
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '20px !important' }}>
                  Szünet
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  14:15
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography fontWeight="bold !important" textAlign='center'>
                    Angol nyelvű főelőadás (ONLINE) magyar fordítással
                  </Typography>

                  <Typography sx={{mt: 2}} fontWeight="bold !important" color='#bc2c2c !important' textAlign='center' fontSize='18px !important'>
                    <b>Prof. Dr. Jaipaul L. Roopnarine</b> játékkutató egyetemi tanár
                    <br />
                    Syracuse University New York, Anton de Kom University of Suriname; University of Guyana, Georgetown
                  </Typography>

                  <Typography sx={{ mt: 1, fontStyle: 'italic !important', fontSize: '16px !important', textAlign: 'center' }}>
                    <b>Beliefs and Engagement Patterns in Mother-Child, Father-Child, and Allocaregiver-Child Play and Cognitive and Social Outcomes in Young Children in Global Majority Contexts</b> / 
                    Az anyák, apák és gondozók gyermekekkel való játékában megjelenő hiedelmek és bevonódási mintázatok, valamint ezek hatása a kisgyermekek kognitív és szociális fejlődésére a világ országaiban
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  15:00
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                  Szünet
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  15:15
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>
                  <Typography fontSize='18px !important' fontWeight="bold !important" textAlign='center'>
                    Panel 3: A tanodák világa és a játék (Elnök: Dr. habil. Bús Imre)
                  </Typography>

                  <Typography sx={{mt: 2}} fontSize='18px !important'>
                    <b>Deák Julianna Dorka</b> - Még több mosolyt az arcokra Tanoda Kecel
                  </Typography>

                  <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    A tanoda, mint gyermekvédelmi intézmény
                  </Typography>

                  <Typography sx={{mt: 1}} fontSize='18px !important'>
                    <b>Jánosi Ferenc</b> - MPE Ifjúság és Családépítő Szolgálat Budapest
                  </Typography>

                  <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Finn Tapasztalatok és Tanulságok: A 'Job Shadowing' Program Elemzése a STEAM Módszertan Tükrében
                  </Typography>

                  <Typography sx={{mt: 1}} fontSize='18px !important'>
                    <b>Farkas Éva</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>

                  <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Hátránykezelés és a szociális kompetenciák fejlesztése játék segítségével a tanodai gyakorlatban
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                  Fsz A
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  16:00
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 4: A játék varázsa és a generációk (Elnök: Dr. habil. V. Gilbert Edit)
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Halina Oster & Michael Oster</b> - KLANZA Lengyel Pedagógusok Egyesülete
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    "Mosollyal az életen át!" Empátia a generációk közötti integrációban a játékpedagógia segítségével.
                    A "Szkoła Dorosłego Człowieka" (Felnőttek iskolája) sikerei (lengyel nyelven magyar fordítással)
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Jánosi Teodóra</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    A gyermek játéka az édesapával
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Vámos Enikő</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    A játékkal kapcsolatos szülői hiedelmek generációs összehasonlítása
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Kelemen Magdolna</b> - Parajd, Erdély, Románia
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    Az erdélyi Sóvidék játékvilága
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                  Fsz A
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  17:00
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                  Reflexiók a napi előadások nyomán (Vezeti: Dr. habil. Bús Imre)
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Fsz A
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
}

export function FridayTableDE() {
  return (
    <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
      <Table sx={{ tableLayout: 'auto', width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Zeit
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Programm
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Raum
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                8:30
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important', fontSize: '20px !important' }}>
                Registration
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                PTE KPVK Eingang
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                9:00 - 9:30
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {`Begrüßung und Eröffnung der Konferenz\n
                - Prof. Dr. Attila Miseta - Universität Pécs, Rektor
                - Prof. Dr. Gábor Szécsi - Universität Pécs, Dekan der FKPLF
                - Dr. Dr. habil. Zsuzsanna Agora - Universität Pécs, FKPLF Hauptorganisatorin der Konferenz
                `}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                9:30 - 10:30
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Hauptvorträge (in englischer Sprache mit ungarischer Übersetzung)\n
                Valeria Spazzoli - Politische Assistentin der Europäische Kommission, Generaldirektion Beschäftigung, Soziales und Inklusion:
                European Child Guarantee
                
                Dr. Francesca Berti - Spielforscherin an der Freien Universität Bolzano:
                Traditional Games and Heritage Education: Connecting the Past, the Present and the Future
                `}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
              Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                10:00 - 11:30
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Workshop\n
                Katherina Kellig - Deutsche Bühne
                "Die ganze Welt ist ein Theater!" Theaterpädagogische Spiele und Methoden zur Verbesserung des Spracherwerbs und der Kommunikation
                `}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Künstlerraum (Nagyterem)
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                10:30
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Gesellschaftsspiele im Dienste der Pädagogik\n
                Dr. Dr. habil. Agora Zsuzsanna (UP FKPLF) - Dr. habil. Edit V. Gilbert (UP FPS) - Dr. habil. Virág Rab (UP FPS) - Zsófia Nemes-Wéber - Prof. Dr. Zsolt Nemeskéri (UP CSER) - Dr. habil. Iván Zádori (UP FKPLF) - Prof. Dr. Sándor Klein (UP FKPLF)
                Gesellschaftsspiele für pädagogische Förderung. Innovationen an der Universität Pécs
                `}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                11:15
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '20px !important' }}>
                Pause
              </Typography>
            </TableCell>
            <TableCell>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                11:30
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Vorträge: Spiel und Förderung (Panelleiter: Dr. Helmut Herman Bechtel)\n
                Mag. Sylvia Cizek - Kirchliche Pädagogische Hochschule Wien, Austria:
                Inklusion- spielend einfach? Schulentwicklungsprozesse als Chance zur Implementierung inklusiver Spielphasen in der Primarstufe

                Mag. Doris Bilgeri - Kirchliche Pädagogische Hochschule Wien, Austria: 
                "Mindful games" - Pädagogische und psychologische Effekte durch den Einsatz von Mindful games (achtsame Spiele) für Kinder und Jugendliche im Schulunterricht

Mag. Astrid Kircher - Kirchliche Pädagogische Hochschule Wien, Austria:
Heute nur gespielt? Der Einfluss des Freispiels auf die holistische Entwicklung von Kindern in der Elementaren Bildung
                `}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important'}}>
                Fsz A
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                12:30
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '20px !important' }}>
                Mittagspause
              </Typography>
            </TableCell>
            <TableCell>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                14:15
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography fontWeight="bold !important" textAlign='center'>
                  Hauptvortrag (in englischer Sprache mit ungarischer Übersetzung)
                </Typography>

                <Typography sx={{mt: 3}} fontWeight="bold !important" color='#bc2c2c !important' textAlign='center' fontSize='18px !important'>
                  <b>Prof. Dr. Jaipaul L. Roopnarine</b> Spielforscher
                  <br />
                  an der Syracuse University New York, Anton de Kom University of Suriname; University of Guyana, Georgetown
                </Typography>

                <Typography sx={{ mt: 1, fontStyle: 'italic !important', fontSize: '16px !important', textAlign: 'center' }}>
                  Beliefs and Engagement Patterns in Mother-Child, Father-Child, and Allocaregiver-Child Play and Cognitive and Social Outcomes in Young Children in Global Majority Contexts
                </Typography>
              </Box>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                15:00
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {`
                Ungarndeutsche Spiele und Workshops
                Josef Weigert und Maria Somlyai-Kőrösi: Begrüßung und Eröffnung des Spielnachmittags\n
                
                Josef Weigert - Ungarndeutsches Pädagogisches und Methodisches Zentrum: 
                Aus der Vergangenheit in die Zukunft:  Gesellschaftsspiele für die Vermittlung ungarndeutscher Kultur für Kinder und Erwachsene

                Maria Somlyai-Kőrösi & Beatrix Leib - Bohler Kindergarten, Kinderkrippe und Mini-Kinderkrippe; Nationalitätenkindergarten Sonnenschein zu Nimmesch: 
                Ungarndeutsche Spielprogramme für Klein(st)kinder

                Detailliertes Programm an Ort und Stelle!
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                15:15
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {`
                Margot Reinig - KL!CK Kindermuseum Hamburg: 
                "Mini-Mathe" Ausstellungseröffnung (Die Ausstellung finden Sie am Freitag und Samstag im Raum Gáspár)
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>
                Gáspár László
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                15:45 - 17:00
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 3}} fontWeight="bold !important" fontSize='18px !important'>
                  <b>Dr. habil. Gerhard Friedrich</b> - Universität Bielefeld, Deutschland
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Spielbasierte frühpädagogische mathematische Bildung: Mathematisches Denken anbahnen - zwischen Bewegung, Handlung und symbolischer Repräsentation, deutschsprachiger Workshop
                </Typography>
              </Box>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                Künstlerraum (Nagyterem)
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                {/* TODO: 15:15 vagy 16:15 ??? */}
                15:15
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 3}} fontWeight="bold !important" fontSize='18px !important'>
                  <b>Maria Gasser-Karsai</b> - Ungarndeutsches Pädagogisches und Methodisches Zentrum
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Feste Karussell. Ungarndeutsche Kultur und Geschichte spielerisch vermitteln, deutschsprachiger Workshop
                </Typography>
              </Box>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                17:00
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '20px !important' }}>
                Reflexionen am Ende des Tages geleitet von Dr. habil. Gerhard Friedrich
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function FridayTableUS() {
  return (
    <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
      <Table sx={{ tableLayout: 'auto', width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Time
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Program
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
              Venue
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                8:30 AM
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important', fontSize: '18px !important' }}>
                Registration
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                PTE KPVK Entrance
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                9:00 AM
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {`Welcome Speeches\n
                - Prof. Dr. Attila Miseta - Rector of University of Pécs
                - Prof. Dr. Gábor Szécsi - Dean of Faculty Cultural Sciences, Education and Rural Development at University of Pécs
                - Dr. Dr. habil. Zsuzsanna Agora - Conference Host, Culture-Identity-History Interdisciplinary Research Group, UP
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                9:30 AM
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `KEYNOTE LECTURES (Chair: Dr. Dr. habil. Zsuzsanna Agora)\n
                Valeria Spazzoli - Policy assistant of the Director for Social Rights and Inclusion, at the European Commission Directorate-General for Employment, Social Affairs and Inclusion, Brussels - Belgium
                European Child Guarantee

                Dr. Francesca Berti - Junior Researcher, General Didactics and Inclusion, Faculty of Education, Free University of Bolzano, Italy
                Traditional Games and Heritage Education: Connecting the Past, the Present and the Future
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                10:30 AM
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Board Game Presentations\n
                Dr. Dr. habil. Zsuzsanna Agora (UP CSER) - Dr. habil. Edit V. Gilbert (UP HSS) - Dr. habil. Virág Rab (UP HSS) - Zsófia Nemes-Wéber - Prof. Dr. Zsolt Nemeskéri (UP CSER) - Dr. habil. Iván Zádori (UP CSER) - Prof. Dr. Sándor Klein (UP CSER)
                  
                Educational Board Games Developed at the University of Pécs
                It's About Us! - Identity and Locality in the Ormánság Region (board game)
                Identities in Between - European Destinies (board game)
                Dienes Games for the Development of Mathematical Thinking
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                Dr. Tóth Tibor
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                11:30 AM
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Panel 1: Concepts of Play (Chairs: Julianna Kiss and Prof. Dr. Sándor Klein)\n
                Dr. Paul Sacher-Toporek - SpielWERT Consulting, Austria
                Defining Play: The Sine Qua Non Condition for Interdisciplinary Understanding

                Tünde Noémi Csiha - University of Sopron, Benedek Elek Faculty of Pedagogy, Hungary
                When the Rule is the Suspension of the Rule

                Dr. Zsófia Böddi, Valéria Kerekes, Dr. Veronika Agg-Pirka - Eötvös Loránd University Budapest, Faculty of Primary and Pre-school Education, Hungary
                Perception of First-Grade Preschool Teacher Students Regarding Play, Preschool, Children, and Their Development
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                Dr. Tóth Tibor
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                  12:30 PM
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                Lunchtime
              </Typography>
            </TableCell>
            <TableCell>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                  1:00 PM
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {
                `Panel 2: Play and Cognitive Development (Chair: Dr. habil. Ágnes Bálint)\n
                Dr. Kristóf Fenyvesi, Imre Kökényesi, Dr. Éva Gyarmathy - Univ. of Jyväskylä, CogniTeach, Apor Vilmos Catholic College, Hungary 
                Cognitive Games in Education: How Can Playful Learning Transform Assessment and Cognitive Development?
	
	              Julianna Kiss, Prof. Dr. Sándor Klein, Prof. Dr. Zsolt Nemeskéri - University of Pécs, Faculty of Cultural Sciences, Education and Rural Development, Hungary: 
                Cognitive Development Games in Mathematics Education
	
	              Dr. habil. Zsuzsanna Schnell - University of Pécs, Faculty of Cultural Sciences, Education and Rural Development, Hungary: 
                Dyslexia in ESL - Gamification and Novel Approaches of Multimodality Serving Neurodiversity in Education
                `}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important'}}>
                Fsz A
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                  2:00 PM
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                Coffee break
              </Typography>
            </TableCell>
            <TableCell>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                2:15 PM
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography fontWeight="bold !important" textAlign='center'>
                  ONLINE KEYNOTE LECTURE
                </Typography>

                <Typography sx={{mt: 2}} fontWeight="bold !important" color='#bc2c2c !important' textAlign='center' fontSize='18px !important'>
                  <b>Prof. Dr. Jaipaul L. Roopnarine</b>
                  <br />
                  Syracuse University New York, Anton de Kom University of Suriname; University of Guyana, Georgetown
                </Typography>

                <Typography sx={{ mt: 1, fontStyle: 'italic !important', fontSize: '16px !important', textAlign: 'center' }}>
                  <b>Beliefs and Engagement Patterns in Mother-Child, Father-Child, and Allocaregiver-Child Play and Cognitive and Social Outcomes in Young Children in Global Majority Contexts</b> / 
                </Typography>
              </Box>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '16px !important' }}>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                3:00 PM
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                Coffee break
              </Typography>
            </TableCell>
            <TableCell>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                3:15 PM
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography fontWeight="bold !important" textAlign='center'>
                  Panel 3: Play and Arts (Chair: Dr. Eszter Tari)
                </Typography>

                <Typography sx={{mt: 2}} fontSize='18px !important'>
                  <b>Prof. Dr. Karl Bardosh</b> - New York University, Tisch School of the Arts, Kanbar Institute of Film/TV, USA
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Creating Art by Playing Audiovisual Games ONLINE
                </Typography>

                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Tímea Deák-Kovács</b> - University of Pécs, Faculty of HSS, Hungary ONLINE
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  The Role of Playful Elements in David Lynch's Narratives and the Freudian Uncanny
                </Typography>

                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Prof. Dr. Tamás Molnár F.</b> - University of Pécs, Medical School, Hungary
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  The Secret Beauty of the Toy Soldier
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                Dr. Tóth Tibor
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 'bold !important' }}>
                4:15 PM
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                Reflecting Remarks: Closing he First Conference Day (Chairs: Julianna Kiss and Prof. Dr. Sándor Klein)
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontSize: '16px !important' }}>
                Dr. Tóth Tibor
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function FridayWorkshopsHU() {
  return (
    <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
      <Table sx={{ tableLayout: 'auto', width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '20px !important' }}>
              Péntek délután: Workshopok, játékok és kiállítások
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>      

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:00 - 16:00
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Radnai Teréz</b>
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  MOZAIK digitális és okos óvoda
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Hidy Péter terem
              </Typography>
            </TableCell>
          </TableRow>
          
          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:00 - 15:15
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography fontSize='18px !important' fontWeight="bold !important" textAlign='center'>
                  Aula játéktér és bemutató megnyitója (német és magyar nyelven)
                </Typography>
                
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Weigert József</b> - Ungarndeutsches Pädagogisches und Methodisches Zentrum
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Aus der Vergangenheit in die Zukunft:  Gesellschaftsspiele für die Vermittlung ungarndeutscher Kultur für Kinder und Erwachsene
                </Typography>

                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Kőrösiné Somlyai Mária & Leib Rolandné</b> - Bólyi Óvoda, Bölcsőde és Mini Bölcsőde; Himesházi Napsugár Német Nemzetiségi Óvoda módszertani programja foglalkoztatóval
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Ungarndeutsche Spielprogramme für Klein(st)kinder (Részletes program a helyszínen)
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:15 - 15:50
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Pozsár Éva & Havlikné Rácz Andrea</b>
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Ovis fürkésző
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:15 -
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Margot Reinig</b> - KL!CK Kindermuseum Hamburg
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  "Mini-Mathe" Ausstellungseröffnung (Mini-Matek: a Hamburgi KL!Ck Gyermekmúzeum kiállítása)
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Gáspár László
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:15 - 
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Soós János</b> - PTE Játékfejlesztő
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Ütközések és Sorozatok: Fejlesztés alatti játékok tesztelése
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>
          
          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                péntek - szombat
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Prof. Dr. Gráfik Imre</b> - Nyugat-Magyarországi Egyetem Művészeti, Nevelés- és Sporttudományi Kar
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  A játékok játéka: a gombfoci (Poszterkiállítás)
                </Typography>
                
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Dr. Bíró Violetta</b> - Pécsi Tudományegyetem KPVK
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Élménnyel az élményért (Kiállítás/Exhibiton)
                </Typography>

                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Aylin Werner</b> - Kirchlich Pädagogische Hochschule Wien
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  The Role of Games in Promoting Resilience (poszter prezentáció/poster presentation)
                </Typography>

                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Michaela Haas</b> - Kirchlich Pädagogische Hochschule Wien
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Play and Children with Special Needs (poszter prezentáció/poster presentation)
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Folyosó tér
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                15:15 -
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Maria Gasser-Karsai</b> - Ungarndeutsches Pädagogisches und Methodisches Zentrum
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Feste Karussell. Ungarndeutsche Kultur und Geschichte spielerisch vermitteln
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ textAlign: 'center' }}>
              <Typography>
                16:00 - 16:45
              </Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{mt: 1}} fontSize='18px !important'>
                  <b>Borsós Zsófia</b>
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Mit kapunk a természettől? - Játék az ökoszisztéma szolgáltatásokkal
                </Typography>
              </Box>
            </TableCell>
            <TableCell>
              <Typography fontSize='16px !important'>
                Koltai Dénes Aula
              </Typography>
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
}